import * as types from '../constants/actionTypes';

const initialState = {
  products: [],
  categories: [],
  units: [],
  taxSlabs: [],
  vendors: [],
  currentProduct: null,
  loading: false,
  error: null,
  formDataLoading: false,
  formDataError: null
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PRODUCTS_REQUEST:
    case types.CREATE_PRODUCT_REQUEST:
    case types.UPDATE_PRODUCT_REQUEST:
    case types.GET_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.FETCH_PRODUCT_FORM_DATA_REQUEST:
      return {
        ...state,
        formDataLoading: true,
        formDataError: null
      };

    case types.FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.products || action.payload,
        categories: action.payload.categories || state.categories,
        units: action.payload.units || state.units,
        taxSlabs: action.payload.tax_slabs || state.taxSlabs,
        vendors: action.payload.vendors || state.vendors,
        error: null
      };

    case types.FETCH_PRODUCT_FORM_DATA_SUCCESS:
      return {
        ...state,
        formDataLoading: false,
        categories: action.payload.categories || [],
        units: action.payload.units || [],
        taxSlabs: action.payload.tax_slabs || [],
        vendors: action.payload.vendors || [],
        formDataError: null
      };

    case types.CREATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: [...state.products, action.payload],
        error: null
      };

    case types.UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: state.products.map(product =>
          product.id === action.payload.id ? action.payload : product
        ),
        error: null
      };

    case types.GET_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        currentProduct: action.payload,
        error: null
      };

    case types.FETCH_PRODUCTS_FAILURE:
    case types.CREATE_PRODUCT_FAILURE:
    case types.UPDATE_PRODUCT_FAILURE:
    case types.GET_PRODUCT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case types.FETCH_PRODUCT_FORM_DATA_FAILURE:
      return {
        ...state,
        formDataLoading: false,
        formDataError: action.payload
      };

    default:
      return state;
  }
};

export default productReducer;